// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"07ec872c","227":"b0c5a162","500":"3602f301","589":"e68fa883","695":"43a5c599","756":"5e565792","811":"502fca08"}[chunkId] + ".chunk.css";
};